import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import InputGroup from 'react-bootstrap/InputGroup';


const AdmnHometution = () => {
  const [getHometutionn, setgetHometution] = useState([]);
  const [nochangedata, setnochangedata] = useState([])
  const gethometution = async () => {
    let res = await axios.get("/api/user/getHometution");
    if (res.status === 200) {
      setgetHometution(res.data.gethometutionn);
      setnochangedata(res.data.gethometutionn)
    }
  };
  const [show4, setShow4] = useState(false);
  const [Data, setData] = useState("");
  const handleClose4 = () => setShow4(false);
  const handleShow4 = (data) => {
    setShow4(true);
    setData(data);
  };
  const Deletehometution = async () => {
    try {
      const config = {
        url: "/user/deleteHometution/" + Data,
        method: "delete",
        baseURL: "/api",
        header: { "content-type": "application/json" },
      };
      await axios(config).then((res) => {
        if (res.status === 200) {
          alert(res.data.success);
          gethometution();
          handleClose4();
        }
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.error);
    }
  };
  const [search, setSearch] = useState("");
  const handleFilter = (e) => {
    if (e.target.value != "") {
      setSearch(e.target.value);
      const filterTable = nochangedata.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
      setgetHometution([...filterTable]);
    } else {
      setSearch(e.target.value);
      setgetHometution([...nochangedata]);
    }
  };
  useEffect(() => {
    gethometution();
  }, []);
  console.log(getHometutionn);

  return (
    <>

      <div className="container  mt-5">
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="do-sear mt-4">
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1"><FontAwesomeIcon icon={faMagnifyingGlass} /></InputGroup.Text>
                <Form.Control
                  placeholder="Search"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  onChange={handleFilter}
                />
              </InputGroup>
            </div>
          </div>

        </div>
        <div className="row">
          <Table striped bordered hover style={{ textAlign: "center" }}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Class Type</th>
                <th>Name</th>
                <th>Grade</th>
                <th>Board</th>
                <th>Subject</th>
                <th>Email</th>
                <th>Contact No.</th>
                <th>Address</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {getHometutionn?.map((item, i) => {
                return (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{item?.EClassType}</td>
                    <td>{item?.ETutionName}</td>
                    <td>{item?.ETutionGrade}</td>
                    <td>{item?.ETutionBoard}</td>
                    <td>{item?.ETutionSubject}</td>
                    <td>{item?.ETutionEmail}</td>
                    <td>{item?.ETutionPhone}</td>
                    <td>{item?.EtutionAddress}</td>
                    <td>{item?.ETutionMsg}</td>

                    <td>
                      <DeleteIcon
                        style={{ color: "red" }}
                        onClick={() => {
                          handleShow4(item?._id);
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
      <Modal
        show={show4}
        onHide={handleClose4}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 style={{ color: "#c0392b" }}>Do You Really Want To Delete...</h3>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose4}>Close</Button>
          <Button onClick={Deletehometution}>Delete </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdmnHometution;
